<template>
    <div class="Products">
      <div class="hero simple" style="background-image: url('/static/asx/child.head.bg.png')">
        <div class="content">
          <h1 class="hero-title">{{ $t('messages.privacyPolicy') }}</h1>
        </div>
      </div>
    </div>
  </template>
      
    <script>
  import CategoryMenu from "@/components/CategoryMenu.vue";
  export default {
    components: {
      CategoryMenu
    }
  };
  </script>
      
    <style scoped>
  .hero.simple {
    height: 475px;
    width: 100%;
    position: relative;
    background-size: cover;
  }
  
  .hero.simple:after {
    z-index: 1;
    content: "";
    background: rgba(0, 0, 0, 0)
      linear-gradient(180deg, #000000 0%, rgba(255, 255, 255, 0) 100%) 0% 0%
      no-repeat padding-box;
    width: 100%;
    height: 100%;
    display: block;
    position: absolute;
    top: 0;
    left: 0;
    opacity: 0.5;
  }
  
  @media (max-width: 1539px) {
    .hero.simple .content {
      padding: 24px 0 18px 48px;
    }
  }
  
  .hero.simple .content {
    position: absolute;
    bottom: 0;
    width: 100%;
    left: 0;
    background: rgba(0, 0, 0, 0)
      linear-gradient(
        90deg,
        var(--unnamed-color-008682) 0%,
        rgba(255, 255, 255, 0) 100%
      )
      0% 0% no-repeat padding-box;
    background: rgba(0, 0, 0, 0)
      linear-gradient(90deg, #0077b4 0%, rgba(255, 255, 255, 0) 100%) 0% 0%
      no-repeat padding-box;
    padding: 24px 0 18px 73px;
  }
  
  .hero.simple .hero-title {
    margin: 0;
    padding: 0;
    color: #fff;
    font-size: 46px;
  }
  </style>


// WEBPACK FOOTER //
// src/components/firstLevel/Privacy.vue